// 顧客種別一覧画面
import React, { useState, useEffect, useCallback } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Snackbar,
  DialogContent,
  DialogContentText,
  Dialog,
  DialogActions,
  DialogTitle,
  Tooltip
} from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import {
  makeStyles,
  withStyles,
  createStyles,
  Theme
} from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import DeleteIcon from '@material-ui/icons/Delete';

import { Redirect } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  isLoggedIn,
  mainBlueColor,
  btnColor,
  customerData,
  userMenuId
} from '../GlobalState';
import {
  getCustomerType,
  saveType,
  editType,
  deleteCustomertypes
} from '../apicalls/getCustomerTypes';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import LoadingComponent from '../components/LoadingComponent';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

interface State {
  arr: any;
}

interface CheckedState {
  check: any;
}

export const CustomerType: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'scroll'
      },
      paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        paddingTop: 30,
        paddingBottom: 30,
        marginTop: 30,
        marginBottom: 30
      },

      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        padding: 8,
        fontWeight: 'bold',
        fontSize: 16
      },
      input: {
        borderColor: '#CCCCCC',
        padding: 5,
        margin: 10
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      table1: {
        padding: 8
      },
      inputtype: {
        minHeight: 45,
        marginBottom: 5,
        width: '100%',
        paddingLeft: 10,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderRadius: 5
      }
    })
  );

  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [editModalType, setEditModalType] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleClickOpenAlert = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const matches2 = useMediaQuery('(min-width:900px)');
  const classes = useStyles();

  const [checkBoxSelected, setCheckBoxSelected] = useState(false);

  const [customerApiData, setCustomerApiData] = useRecoilState(customerData);
  const changeCustomerApiData = useCallback(
    (newData: any) => setCustomerApiData(newData),
    [setCustomerApiData]
  );

  const [apiData, setApiData] = useState<any>(
    customerApiData !== null ? customerApiData : []
  );
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(
    customerApiData !== null ? false : true
  );

  const [type, setType] = useState('');
  const [typeid, setTypeId] = useState<number>(0);

  const [customerIds, setCustomerIds] = useState<State>({ arr: [] });
  const [checked, setChecked] = useState<CheckedState>({ check: [] });
  const [pressed, setPressed] = useState([]);
  const [isSelected, setSelection] = useState(false);
  const [userMenu] = useRecoilState<any>(userMenuId);

  const [openModalType, setOpenModalType] = useState(false);

  const [count, setCount] = useState(0);

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const getCustomerTypes = useCallback(() => {
    getCustomerType().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            changeCustomerApiData(data.data);
            setApiData(data.data);
            setCount(data.data.length);
            setLoading(false);
            setCustomerIds({ arr: [] });
            setChecked({ check: [] });
            setSelection(false);
            //setPageCount(data.page_count);
            //setMyCheckExport(data.selected_columns);
          }
        }
      }
    });
  }, [changeLoggedInData, changeCustomerApiData]);

  const saveCustomerType = () => {
    if (type.trim() === '') {
      setErrorMessage('タイプを入力してください。');
      setOpen(true);
    } else {
      saveType(type.trim()).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setSuccessMessage(data.message);
              setOpenSuccess(true);
              setOpenModalType(false);
              setTimeout(() => {
                setType('');
                setTypeId(0);
                getCustomerTypes();
              }, 1000);
            }
          }
        }
      });
    }
  };

  const editCustomerType = () => {
    if (type.trim() === '') {
      setErrorMessage('タイプを入力してください。');
      setOpen(true);
    } else {
      editType(typeid, type.trim()).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setSuccessMessage(data.message);
              setOpenSuccess(true);
              setEditModalType(false);
              setTimeout(() => {
                setType('');
                setTypeId(0);
                getCustomerTypes();
                getCustomerTypes();
              }, 1000);
            }
          }
        }
      });
    }
  };

  useEffect(() => {
    getCustomerTypes();
  }, [getCustomerTypes]);

  const deleteSelectedCustomerstype = () => {
    console.log('inside delete function', customerIds);
    deleteCustomertypes(customerIds.arr).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setSuccessMessage(data.message);
            setOpenSuccess(true);
            setOpenAlert(false);
            getCustomerTypes();
          }
        }
      }
    });
  };

  function handleChange(index: number) {
    for (let i = 0; i < count; i++) {
      if (checked.check[i] === false) {
        setSelection(false);
      }
    }

    let checkedBox: any = [...checked.check];
    checkedBox[index] = !checked.check[index];
    setChecked({ check: checkedBox });
  }

  const selectAllCheckBoxPressed = () => {
    let a = [];
    if (isSelected === false) {
      let subjectArray: any = [];
      setCustomerIds({ arr: [] });

      setChecked({ check: [] });
      setPressed([]);
      for (let i = 1; i <= count; i++) {
        a.push(true);
        setChecked({ check: a });
      }

      apiData.map((item: any, k: number) => subjectArray.push(item.id));
      setCustomerIds({ arr: subjectArray });
    } else {
      //subject ids
      setCustomerIds({ arr: [] });
      for (let i = 1; i <= count; i++) {
        a.push(false);
        setChecked({ check: a });
      }
    }
  };
  const handleOpenType = () => {
    setOpenModalType(true);
  };
  const handleCloseType = () => {
    setType('');
    setOpenModalType(false);
  };
  const handleEditType = () => {
    setEditModalType(true);
  };
  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };
  const handleEditCloseType = () => {
    setType('');
    setTypeId(0);
    setEditModalType(false);
  };

  const [fullWidth] = useState(true);
  const [maxWidth] = useState<DialogProps['maxWidth']>('sm');

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  if (userMenu == 'Storage') {
    return (
      <Redirect
        to={{
          pathname: '/constructions'
        }}
      />
    );
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName='customertypes' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          {openSuccess ? (
            <Snackbar
              open={openSuccess}
              autoHideDuration={2000}
              onClose={handleCloseSuccess}
            >
              <Alert onClose={handleCloseSuccess} severity='success'>
                {successMessage}
              </Alert>
            </Snackbar>
          ) : null}

          <div className={matches2 ? 'main-container-customer' : ''}>
            <div></div>
            <div
              className={
                matches2
                  ? 'top-Container-customer'
                  : 'top-Container-customer-responsive'
              }
            ></div>
          </div>

          <div
            style={{ padding: 15, backgroundColor: '#FFFFFF', borderRadius: 5 }}
          >
            <div className='table-top-container-customer'>
              <div style={{ fontWeight: 'bold' }}>顧客種別</div>
              <div style={{ display: 'flex' }}>
                <Button
                  style={{
                    backgroundColor: buttonColor,
                    marginRight: 10,
                    marginBottom: !matches2 ? 10 : 0
                  }}
                  variant='contained'
                  color='secondary'
                  startIcon={<NoteAddIcon />}
                  onClick={() => handleOpenType()}
                >
                  新規作成
                </Button>
                <CustomTooltip
                  title={tooltipContents.customertypesSelectDelete}
                  placement='top'
                >
                  <Button
                    style={{
                      backgroundColor: buttonColor,
                      marginRight: 10,
                      marginBottom: !matches2 ? 10 : 0
                    }}
                    variant='contained'
                    color='secondary'
                    startIcon={<DeleteIcon />}
                    onClick={() => {
                      if (customerIds.arr.length <= 0) {
                        alert('対象を選択してください。');
                      } else {
                        handleClickOpenAlert();
                      }
                    }}
                  >
                    選択削除
                  </Button>
                </CustomTooltip>
              </div>
            </div>
            <Dialog
              fullWidth={fullWidth}
              maxWidth={maxWidth}
              open={openModalType}
              onClose={handleCloseType}
              aria-labelledby='max-width-dialog-title'
            >
              <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                  <div>
                    <div
                      style={{
                        marginTop: '10%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '5%',
                        color: '#000000'
                      }}
                    >
                      顧客種別マスタ名を入力してください
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: '10%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginBottom: '15%',
                      paddingRight: 30
                    }}
                  >
                    <input
                      value={type}
                      maxLength={30}
                      onChange={text => {
                        setType(text.target.value);
                      }}
                      className={classes.inputtype}
                    />
                  </div>
                </DialogContentText>
              </DialogContent>
              <DialogActions style={{ paddingRight: 30, marginBottom: 20 }}>
                <Button
                  style={{
                    marginLeft: matches2 ? 20 : 0,
                    backgroundColor: buttonColor,
                    marginBottom: 15,
                    color: '#FFFFFF'
                  }}
                  onClick={() => {
                    saveCustomerType();
                  }}
                  color='primary'
                  autoFocus
                >
                  作成
                </Button>
                <Button
                  style={{
                    marginLeft: matches2 ? 20 : 0,
                    backgroundColor: buttonColor,
                    marginBottom: 15,

                    color: '#FFFFFF'
                  }}
                  onClick={handleCloseType}
                  color='primary'
                >
                  キャンセル
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              fullWidth={fullWidth}
              maxWidth={maxWidth}
              open={editModalType}
              onClose={handleEditCloseType}
              aria-labelledby='max-width-dialog-title'
            >
              <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                  <div>
                    <div
                      style={{
                        marginTop: '10%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '5%'
                      }}
                    >
                      顧客種別マスタ名を入力してください
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: '10%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginBottom: '15%',
                      paddingRight: 30
                    }}
                  >
                    <input
                      value={type}
                      maxLength={30}
                      onChange={text => {
                        setType(text.target.value);
                      }}
                      className={classes.inputtype}
                    />
                  </div>
                </DialogContentText>
              </DialogContent>
              <DialogActions style={{ paddingRight: 30, marginBottom: 20 }}>
                <Button
                  style={{
                    marginLeft: matches2 ? 20 : 0,
                    backgroundColor: buttonColor,
                    marginBottom: 15,
                    color: '#FFFFFF'
                  }}
                  onClick={() => {
                    editCustomerType();
                  }}
                  color='primary'
                  autoFocus
                >
                  保存
                </Button>
                <Button
                  style={{
                    marginLeft: matches2 ? 20 : 0,
                    backgroundColor: buttonColor,
                    marginBottom: 15,
                    color: '#FFFFFF'
                  }}
                  onClick={handleEditCloseType}
                  color='primary'
                >
                  キャンセル
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={openAlert}
              onClose={handleCloseAlert}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
            >
              <DialogTitle id='alert-dialog-title'>
                {'選択したタイプを削除しますか?'}
              </DialogTitle>
              <DialogActions>
                <Button onClick={handleCloseAlert} color='primary'>
                  キャンセル
                </Button>
                <Button
                  onClick={() => {
                    deleteSelectedCustomerstype();
                  }}
                  color='primary'
                  autoFocus
                >
                  削除
                </Button>
              </DialogActions>
            </Dialog>

            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell className={classes.table} align='center'>
                      <CustomTooltip
                        title={tooltipContents.selectDelete}
                        placement='top'
                      >
                        <Checkbox
                          checked={isSelected}
                          onClick={() => {
                            setSelection(!isSelected);
                            selectAllCheckBoxPressed();
                          }}
                          style={{
                            color: isSelected ? buttonColor : '#FFFFFF'
                          }}
                        />
                      </CustomTooltip>
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      タイプ
                    </StyledTableCell>

                    <StyledTableCell
                      className={classes.table}
                      align='center'
                    ></StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {apiData.map((row: any, index: number) => (
                    <StyledTableRow key={row.id}>
                      <StyledTableCell
                        className={classes.table1}
                        align='center'
                      >
                        <CustomTooltip
                          title={tooltipContents.selectDelete}
                          placement='top'
                        >
                          <Checkbox
                            checked={checked.check[index] ? true : false}
                            onClick={() => {
                              handleChange(index);
                              let newArr = customerIds.arr;
                              if (!checked.check[index] && !pressed[index]) {
                                newArr.push(row.id);
                                setCustomerIds({ arr: newArr });
                              } else {
                                var ind = customerIds.arr.indexOf(row.id);
                                if (ind !== -1) customerIds.arr.splice(ind, 1);
                              }
                              setCheckBoxSelected(!checkBoxSelected);
                            }}
                            style={{
                              color: checked.check[index]
                                ? buttonColor
                                : '#758283'
                            }}
                          />
                        </CustomTooltip>
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                      >
                        {row.name}
                      </StyledTableCell>

                      <StyledTableCell
                        className={classes.table1}
                        align='center'
                      >
                        <Button
                          style={{ backgroundColor: buttonColor }}
                          variant='contained'
                          color='primary'
                          onClick={() => {
                            setTypeId(row.id);
                            setType(row.name);
                            setTimeout(() => {
                              handleEditType();
                            }, 1000);
                          }}
                        >
                          編集
                        </Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              {!loading && apiData.length === 0 && (
                <div className={classes.container}>データがありません</div>
              )}
            </TableContainer>
          </div>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
